import { z } from "zod"

export const TagSchema = z.object({
  id: z.number(),
  name: z.string(),
  order: z.number(),
})

export const TagFormSchema = z.object({
  name: z.string().min(1, "tags.validation.nameRequired"),
  order: z.number().min(0).default(0),
})

export type Tag = z.infer<typeof TagSchema>
export type TagFormValues = z.infer<typeof TagFormSchema>
